export default __webpack_public_path__ + "static/media/landingObjectives.00b81a30.jpg";